<app-admin-menu></app-admin-menu>

<h1 class="mat-headline-3">Personalregister</h1>

<div class="container">
    <div class="row">
        <div class="col">
            <mat-card class="compact employees-list">
                <mat-card-content>
                    <app-employees-list (filterChanged)="updateQueryParameters($event)" [query]="query" [companyIds]="companyIds"
                        [employmentTypeIds]="employmentTypeIds" [departmentIds]="departmentIds" [registeredFrom]="registeredFrom"
                        [registeredTo]="registeredTo" [active]="active" [page]="page">
                    </app-employees-list>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>

<app-messages #messagesPartial [employeeId]="employeeId"></app-messages>

<app-admin-footer></app-admin-footer>
